import TableContainer from 'Common/TableContainer';
import { LucideDot, Plus } from 'lucide-react';
import { useListRoles } from '../../hooks';
import { ModalAddRoles } from '../../components';
import DeleteModal from 'Common/DeleteModal';
import { useTranslation } from 'react-i18next';
import BreadCrumb from 'Common/BreadCrumb';
import { BasicButton } from 'Common/Components/UI/Atoms/Buttons';
import { useRoleStore } from '../../store';

const RolesView = () => {
  const {
    columns,
    deleteModal,
    deleteToggle,
    roleRows,
    onDeleteConfirm
  } = useListRoles();
  const { t } = useTranslation();
  const { handleOpenModalRole } = useRoleStore();

  return (
    <>
      <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
        <BreadCrumb
          title={t('rolesScreen.Title')}
          pageTitle={t('rolesScreen.formAdminRoles.TitleCreate')}
        />
        <div className="card">
          <div className="card-body">
            <div className='flex w-full items-center justify-end flex-wrap'>
              <div className='mt-4'>
                <BasicButton onClick={handleOpenModalRole} type="button">
                  <div className="flex flex-row justify-center items-center">
                    <LucideDot size={16} color="#fff" />
                    <span className='ml-2 text-slate-50'>
                      {t('rolesScreen.formAdminRoles.TitleCreate')}
                    </span>
                  </div>
                </BasicButton>
              </div>
            </div>
            <div className="w-full pt-6">
              <TableContainer
                isPagination={true}
                columns={columns}
                data={roleRows}
                isTfoot={false}
                isSelect={true}
                isGlobalFilter={true}
                divclassName="my-2 col-span-12 overflow-x-auto lg:col-span-12"
                tableclassName="display stripe group dataTable w-full text-sm align-middle whitespace-nowrap"
                theadclassName="border-b border-slate-200 dark:border-zink-500"
                thclassName="ltr:!text-left rtl:!text-right p-3 group-[.bordered]:border group-[.bordered]:border-slate-200 group-[.bordered]:dark:border-zink-500 sorting px-3 py-4 text-slate-900 bg-slate-200/50 font-semibold text-left dark:text-zink-50 dark:bg-zink-600 dark:group-[.bordered]:border-zink-500 sorting_asc"
                tdclassName="p-3 group-[.bordered]:border group-[.bordered]:border-slate-200 group-[.bordered]:dark:border-zink-500"
                PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
              ></TableContainer>
            </div>
            <DeleteModal
              show={deleteModal}
              onHide={deleteToggle}
              onDelete={onDeleteConfirm}
            />
            <ModalAddRoles></ModalAddRoles>
          </div>
        </div>
      </div>
    </>
  );
};

export default RolesView